import { ApiAccountKeyTableKeys } from "@sso/types";
import { APIAccountKeys, SearchFieldKeys, TableColumn } from "@sso/types";

export const apiAccountsTableColumns: TableColumn<APIAccountKeys>[] = [
  {
    name: "Name",
    field: APIAccountKeys.NAME,
    sortable: true,
    search: { type: SearchFieldKeys.TEXT },
  },
  {
    name: "Product",
    field: APIAccountKeys.SOFTWARES_NAME,
    sortable: true,
    search: { type: SearchFieldKeys.TEXT },
  },
  {
    name:"Organisation",
    field: APIAccountKeys.ORGANISATION_NAME,
    sortable: true,
    search: { type: SearchFieldKeys.TEXT },
  },
  {
    name: "Last used",
    field: APIAccountKeys.LAST_USED,
    sortable: true,
  },
];

export const projectsApiKeysTableColumns: TableColumn<ApiAccountKeyTableKeys>[] = [
  {
    name: "Description",
    field: ApiAccountKeyTableKeys.Descriptor,
  },
  {
    name: "Created",
    field: ApiAccountKeyTableKeys.Created,
  },
  {
    name: "Expiry Date",
    field: ApiAccountKeyTableKeys.ExpiryDate,
  },
];
